if (window.hasErrors) {
    $(function () {
        $(".form").effect("shake");
        $("input[placeholder=Password]").val("");
    });
}
